namespace SSi.Blazor.Common.Shared.Wasm.SignaturePad {
    // ReSharper disable once InconsistentNaming
    declare var DotNet: any;
    // ReSharper disable once InconsistentNaming
    declare var Sketchpad: any;

    /* SignaturePad */
    var sigPadElement = null;
    var sigPad = null;
    var sigPadError = "";

    // resize
    if (screen.orientation !== null) {
        screen.orientation.onchange = () => {
            if (sigPadElement !== null && sigPad !== null) {
                sigPad.resize(sigPadElement.offsetWidth);
            }
        }
    }
    else {
        window.onorientationchange = () => {
            if (sigPadElement !== null && sigPad !== null) {
                sigPad.resize(sigPadElement.offsetWidth);
            }
        }
    }

    window.onresize = () => {
        if (sigPadElement !== null && sigPad !== null) {
            sigPad.resize(sigPadElement.offsetWidth);
        }
    }

    /*
     window.onresize = function () {
        dotNetHelper.invokeMethodAsync('UpdateImage');
    }*/

    export function createSignaturePad(divId: string, dotNetHelper): boolean {
        try {
            sigPadError = "";

            // Initialize Sketchpad
            sigPadElement = document.getElementById(divId);
            sigPad = new Sketchpad(sigPadElement,
                {
                    line: {
                        color: '#000000',
                        size: 5
                    },
                    aspectRatio: 0.5
                });
            sigPad.clear();
            
            //sigPad.canvas.addEventListener("focusout", e => { canvasFocusOutEvent(e) });
            //sigPad.addEventListener("focusout", e => { canvasFocusOutEvent(e) });
            
            if (sigPad !== null && sigPad.canvas !== null) {
                var canvas = sigPad.canvas;
                //canvas.onfocusout = () => {canvasFocusOutEvent()};

                if (window.PointerEvent) {
                    // Yay, we can use pointer events!
                    canvas.addEventListener('pointerleave', e => {canvasFocusOutEvent(e, dotNetHelper)}, false);
                } else {
                    // Back to mouse and touch events, I guess.
                    canvas.addEventListener('mouseout', e => {canvasFocusOutEvent(e, dotNetHelper)}, false);
                    canvas.addEventListener('touchend', e => {canvasFocusOutEvent(e, dotNetHelper)}, false);
                }

            }

            return true;
        } catch (ex) {
            sigPadError = `${ex}`;
            return false;
        }
    };



    //export function removeListeners(): void {
    //    if (sigPad !== null) {
    //        sigPad.canvas.removeEventListener("focusout", focusoutEvent);
    //    }
    //}

    //var prevValue = "";
    export function canvasFocusOutEvent(e, dotNetHelper): void {
        const data = getSignaturePadData();
        const dataLength = getSignaturePadDataLength();
        //if (prevValue === data)
        //    return;
        //prevValue = data;
        dotNetHelper.invokeMethodAsync('SignaturePadDataChanged', data, dataLength);
    }


    export function getSignaturePadError(): string {
        return sigPadError;
    };

    export function getSignaturePadData(): string {
        return sigPad.toDataURL('image/png');
        //return sigPad.toDataURL('image/jpeg', 0.8);
    };

        export function getSignaturePadDataLength(): number {
        //return sigPad.isEmpty();
        if (sigPad === null || sigPad.canvas === null) {
            return -1;
        }

        var canvas = sigPad.canvas;
        // returns true if every pixel's uint32 representation is 0 (or "blank")
        const context = sigPad.canvas.getContext('2d');

        const pixelBuffer = new Uint32Array(
            context.getImageData(0, 0, canvas.width, canvas.height).data.buffer
        );
        return pixelBuffer.filter(x => x !== 0).length;
    };

    export function getSignaturePadIsEmpty(): boolean {
        //return sigPad.isEmpty();
        if (sigPad === null || sigPad.canvas === null) {
            return true;
        }

        var canvas = sigPad.canvas;
        // returns true if every pixel's uint32 representation is 0 (or "blank")
        const context = sigPad.canvas.getContext('2d');

        const pixelBuffer = new Uint32Array(
            context.getImageData(0, 0, canvas.width, canvas.height).data.buffer
        );

        return !pixelBuffer.some((color => color !== 0) as any);
    };

    export function clearSignaturePad(): void {
        if (sigPad === null) {
            return;
        }
        sigPad.clear();
    };

    export function setSignaturePadData(dataUri: string): boolean {
        if (sigPad === null || sigPad.canvas === null) {
            return false;
        }

        var canvas = sigPad.canvas;
        var img = new window.Image();
        img.addEventListener("load", () => {
            canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);
        });

        img.setAttribute("src", dataUri);
        return true;
    };

}
